export const styles = {
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '50vh'
    },
    rightAlignment:{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '1em',
        mb:4,
        mt:2
    },
    showMessage: {
        '& img': {
            width: "25em",
            height: '100%',
            '@media (max-width:39.28em)': {
                width: '100%',
            }
        }
    }
}
